import { useContext } from "react";
import ReportShowAllCheckbox from "components/ReportShowAllCheckbox";
import { TrendReportContext } from "contexts/TrendReportContext/TrendReportContext";

const DowntimeSummaryByFailureTypeCheckbox = () => {
    const {
        showAllFailureTypes,
        handleShowAllFailureTypesChange,
        selectedPreviousFailureType,
        selectedFailureType,
        handleSelectedPreviousFailureTypeChange,
        handleSetSelectedFailureType,
    } = useContext(TrendReportContext);

    return (
        <ReportShowAllCheckbox
            checked={showAllFailureTypes}
            onChange={(_, checked) => {
                handleShowAllFailureTypesChange(checked);
                if (checked) {
                    handleSelectedPreviousFailureTypeChange(selectedFailureType);
                    handleSetSelectedFailureType(undefined);
                } else {
                    handleSetSelectedFailureType(selectedPreviousFailureType);
                }
            }}
        />
    );
};

export default DowntimeSummaryByFailureTypeCheckbox;
